import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Attribute } from '../attribute/attribute'

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {

  @Input() parent: FormGroup
  @Input() attribute: Attribute

  get invalid() {
    const ctrl = this.parent.get(this.attribute.value)

    const required = (ctrl.hasError('required') && ctrl.touched) || (ctrl.hasError('invalid') && ctrl.touched)
    return {required}
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/checkbox/checkbox.component.ts